"use strict";
exports.__esModule = true;
exports.RequestBuilder = exports.Request = exports.RequestType = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var RequestType;
(function (RequestType) {
    RequestType["PLATFORM_PRODUCER_CONTRACT_CHANGE"] = "PLATFORM_PRODUCER_CONTRACT_CHANGE";
    RequestType["PLATFORM_MERCHANT_CONTRACT_CHANGE"] = "PLATFORM_MERCHANT_CONTRACT_CHANGE";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
var Request = /** @class */ (function () {
    function Request() {
    }
    Request.hasActivitiesCompleted = function (request) {
        return (request.activities.length === 1);
    };
    Request.isFinished = function (request) {
        return (request.finishedAt !== undefined) && (request.finishedAt !== null);
    };
    Request.isAccepted = function (request) {
        if (Request.hasActivitiesCompleted(request)) {
            return request.activities[0].approval.accepted;
        }
        return undefined;
    };
    Request.isCurrentTimeBeforeValidity = function (request) {
        return request.validUntil.toMillis() > core_common_logic_1.CommonLogic.nowToDateTime().toMillis();
    };
    return Request;
}());
exports.Request = Request;
var RequestBuilder = /** @class */ (function () {
    function RequestBuilder(request) {
        this.request = request;
    }
    RequestBuilder.initiateWithRequest = function (request) {
        return new RequestBuilder(request);
    };
    RequestBuilder.initiateWithNewPlatformMerchantContractChange = function (platformMerchantContractChange) {
        return new RequestBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            type: RequestType.PLATFORM_MERCHANT_CONTRACT_CHANGE,
            participantPartyIds: [platformMerchantContractChange.requester.partyId, platformMerchantContractChange.approver.partyId],
            request: {
                platformMerchantContractChange: platformMerchantContractChange
            },
            activities: [],
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            validUntil: core_common_logic_1.CommonLogic.nowToDateTime().plus({ days: 7 }),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    RequestBuilder.initiateWithNewPlatformProducerContractChange = function (platformProducerContractChange) {
        return new RequestBuilder({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            type: RequestType.PLATFORM_PRODUCER_CONTRACT_CHANGE,
            participantPartyIds: [platformProducerContractChange.requester.partyId, platformProducerContractChange.approver.partyId],
            request: {
                platformProducerContractChange: platformProducerContractChange
            },
            activities: [],
            createdAt: core_common_logic_1.CommonLogic.nowToDateTime(),
            validUntil: core_common_logic_1.CommonLogic.nowToDateTime().plus({ days: 7 }),
            updatedAt: core_common_logic_1.CommonLogic.nowToDateTime()
        });
    };
    RequestBuilder.prototype.build = function () {
        return this.request;
    };
    RequestBuilder.prototype.getId = function () {
        return this.request.id;
    };
    RequestBuilder.prototype.isAccepted = function () {
        return Request.isAccepted(this.request);
    };
    RequestBuilder.prototype.isFinished = function () {
        return Request.isFinished(this.request);
    };
    RequestBuilder.prototype.buildUpdate = function () {
        var req = this.build();
        return {
            type: req.type,
            participantPartyIds: req.participantPartyIds,
            request: req.request,
            activities: req.activities,
            validUntil: req.validUntil,
            finishedAt: req.finishedAt
        };
    };
    RequestBuilder.prototype.addActivityApproval = function (accepted, note, approverPartyId, approverUserId) {
        /* Various sanity checks */
        if (Request.hasActivitiesCompleted(this.request))
            throw new core_common_domain_1.Exception("Cannot approve the request " + this.request.id + " because it has already been completed.");
        if (!Request.isCurrentTimeBeforeValidity(this.request))
            throw new core_common_domain_1.Exception("Cannot approve the request because it is no longer valid.");
        if (!this.request.participantPartyIds.includes(approverPartyId))
            throw new core_common_domain_1.Exception("Cannot approve the request " + this.request.id + " from party " + approverPartyId + " because it is not in the permitted approvers.");
        switch (this.request.type) {
            case RequestType.PLATFORM_MERCHANT_CONTRACT_CHANGE:
                if ((approverUserId !== undefined) && (this.request.request.platformMerchantContractChange.approver.userId !== approverUserId))
                    throw new core_common_domain_1.Exception("Cannot approve the request " + this.request.id + " from party " + approverPartyId + " and user " + approverUserId + " because it is not in the permitted approvers.");
                break;
            case RequestType.PLATFORM_PRODUCER_CONTRACT_CHANGE:
                if ((approverUserId !== undefined) && (this.request.request.platformProducerContractChange.approver.userId !== approverUserId))
                    throw new core_common_domain_1.Exception("Cannot approve the request " + this.request.id + " from party " + approverPartyId + " and user " + approverUserId + " because it is not in the permitted approvers.");
                break;
        }
        var activity = {
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            participant: {
                partyId: approverPartyId,
                userId: approverUserId
            },
            approval: {
                accepted: accepted,
                note: note
            }
        };
        this.request.activities = [activity];
        return this;
    };
    RequestBuilder.prototype.markAsFinished = function () {
        this.request.finishedAt = core_common_logic_1.CommonLogic.nowToDateTime();
        return this;
    };
    RequestBuilder.prototype.markAsFinishedIfActivitiesCompleted = function () {
        if (Request.hasActivitiesCompleted(this.request)) {
            return this.markAsFinished();
        }
        return this;
    };
    return RequestBuilder;
}());
exports.RequestBuilder = RequestBuilder;
